<template>
  <main class="w-full flex-grow p-6">
    <BackButton />
    <div class="flex justify-between items-center">
      <div class="">
        <h1 class="text-3xl font-bold text-app-default">Video Event/Detail</h1>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Video Event Info</div>
            <div @click="showModalEditPromoInfo" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="font-semibold">Name</div>
          <div v-if="dataEvent.event_name !== ''" class="ml-5">
            {{ dataEvent.name }}
          </div>
          <div v-else class="ml-5">-</div>
          <div class="font-semibold">URL</div>
          <div v-if="dataEvent.url !== ''" class="ml-5">
            {{ dataEvent.url }}
          </div>
          <div v-else class="ml-5">-</div>
          <div class="font-semibold">Type</div>
          <div v-if="dataEvent.status === 'default'" class="ml-5">
            Default
          </div>
          <div v-else class="ml-5">Limited Time</div>
          <div class="font-semibold">Start</div>
          <div v-if="dataEvent.event_start !== null" class="ml-5">
            {{ event_start }}
          </div>
          <div v-else class="ml-5">-</div>
          <div class="font-semibold">End</div>
          <div v-if="dataEvent.event_end !== null" class="ml-5">
            {{ event_end }}
          </div>
          <div v-else class="ml-5">-</div>
          <div class="font-semibold">Status</div>
          <div v-if="dataEvent.is_active" class="ml-5">Active</div>
          <div v-else class="ml-5">Non Active</div>
        </div>
      </div>
    </div>

    <!-- Modal Update -->
    <div
      v-if="modalInfoPromo"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 800px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <button
            @click.self="showModalEditPromoInfo"
            class="fill-current h-6 w-6 absolute right-0 top-0 m-6 font-3xl font-bold"
          >
            &times;
          </button>
          <div class="px-6 py-3 text-xl border-b font-bold">Edit</div>
          <div class="p-6 flex-grow">
            <div class="flex flex-wrap">
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Status</label
                >
                <div class="flex flex-row items-center h-9 mb-5">
                  <div
                    class="relative cursor-pointer"
                    @click="update.is_active = !update.is_active"
                  >
                    <div
                      class="w-10 h-4 bg-gray-400 rounded-full shadow-inner items-center p-1 duration-300 ease-in-out"
                      :class="{ 'bg-app-default': update.is_active }"
                    ></div>
                    <div
                      class="absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition transform duration-300 ease-in-out"
                      :class="{ 'translate-x-6': update.is_active }"
                    ></div>
                  </div>
                </div>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80">Name</label>
                <input
                  v-model="update.name"
                  @keyup="nameChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.name
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Name"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.name_msg }}
                </div>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80">URL</label>
                <input
                  v-model="update.url"
                  @keyup="urlChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.url
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="ex: https://www.facebook.com/23paskal/videos/631828537799142/"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.url_msg }}
                </div>
              </div>
              <div
                class="w-full lg:w-1/2 pr-0 lg:pr-2"
                :class="{ hidden: update.status === 'default' }"
              >
                <label class="font-semibold text-black opacity-80">Start</label>
                <v-date-picker
                  timezone="Asia/Jakarta"
                  v-model="update.event_start"
                  mode="dateTime"
                  is24hr
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input
                      class="px-2 py-1 border-2 border-gray-200 rounded focus:outline-none focus:border-blue-300 w-full"
                      :value="inputValue"
                      v-on="inputEvents"
                    />
                  </template>
                </v-date-picker>
              </div>
              <div
                class="w-full lg:w-1/2 pr-0 lg:pr-2"
                :class="{ hidden: update.status === 'default' }"
              >
                <label class="font-semibold text-black opacity-80">End</label>
                <v-date-picker
                  timezone="Asia/Jakarta"
                  v-model="update.event_end"
                  mode="dateTime"
                  is24hr
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input
                      class="px-2 py-1 border-2 border-gray-200 rounded focus:outline-none focus:border-blue-300 w-full"
                      :value="inputValue"
                      v-on="inputEvents"
                    />
                  </template>
                </v-date-picker>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalEditPromoInfo"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click="updatePromoInfo"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalEditPromoInfo"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <Warning />
    <SuccessNotif />
  </main>
</template>

<script>
import API from "../../api";
import Warning from "../../components/Warning.vue";
import BackButton from "../../components/BackButton.vue";
import SuccessNotif from "../../components/SuccessNotif.vue";
export default {
  name: "ContentDetail",
  components: {
    Warning,
    BackButton,
    SuccessNotif,
  },
  data() {
    return {
      dataEvent: {},
      modalInfoPromo: false,
      event_start: "",
      event_end: "",
      errors: {
        name: false,
        name_msg: "",
        url: false,
        url_msg: "",
        status: false,
        status_msg: "",
        is_active: false,
        is_active_msg: "",
      },
      update: {
        name: "",
        url: "",
        status: "",
        event_start: new Date(),
        event_end: new Date(),
        is_active: true,
      },
      saveButton: "Save",
      deleteButton: "Delete",
    };
  },
  methods: {
    nameChange: function(e) {
      this.update.name = e.target.value;
      this.errors.name = false;
      this.errors.name_msg = "";
    },
    urlChange: function(e) {
      this.update.url = e.target.value;
      this.errors.url = false;
      this.errors.url_msg = "";
    },
    showModalEditPromoInfo: function() {
      this.update.name = this.dataEvent.name;
      this.update.url = this.dataEvent.url;
      this.update.status = this.dataEvent.status;
      this.update.event_start = new Date(this.dataEvent.event_start);
      this.update.event_end = new Date(this.dataEvent.event_end);
      this.update.is_active = this.dataEvent.is_active;
      this.modalInfoPromo = !this.modalInfoPromo;
    },
    updatePromoInfo: async function() {
      let data = {
        id: this.dataEvent.id,
        name: this.update.name,
        url: this.update.url,
        status: this.update.status,
        // event_start: this.update.event_start,
        // event_end: this.update.event_end,
        is_active: this.update.is_active,
      };
      this.saveButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/cms/event/video/update`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify(data),
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "name") {
                this.errors.name = true;
                this.errors.name_msg = item.message;
              }
              if (item.key === "url") {
                this.errors.url = true;
                this.errors.url_msg = item.message;
              }
              if (item.key === "status") {
                this.errors.status = true;
                this.errors.status_msg = item.message;
              }
              if (item.key === "is_active") {
                this.errors.is_active = true;
                this.errors.is_active_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this.saveButton = "Save";
          return;
        }
        this.modalInfoPromo = false;
        this.detailEvent();
        this.saveButton = "Save";
        this._success("Data updated.");
      } catch (err) {
        this.modalInfoPromo = false;
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    detailEvent: async function() {
      try {
        let res = await fetch(
          `${API}v1/admin/cms/event/video/${this.$route.params.id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error(respon.message);
          return;
        }
        this.dataEvent = respon.data;
        let stE = new Date(respon.data.event_start);
        let enE = new Date(respon.data.event_end);
        this.event_start = `${stE.getDate()}-${stE.getMonth() +
          1}-${stE.getFullYear()} ${stE.getHours()}:${stE.getMinutes()}`;
        this.event_end = `${enE.getDate()}-${enE.getMonth() +
          1}-${enE.getFullYear()} ${enE.getHours()}:${enE.getMinutes()}`;
      } catch (err) {
        this._error("internal server error");
      }
    },
    _error: function(message) {
      this.$store.dispatch("warning", {
        isError: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("warning", {
          isError: false,
          message: "",
        });
      }, 5000);
    },
    _success: function(message) {
      this.$store.dispatch("success", {
        isSuccess: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("success", {
          isSuccess: false,
          message: "",
        });
      }, 5000);
    },
  },
  created() {
    this.detailEvent();
  },
};
</script>
